import '../scss/components/topic-carousel.scss';
import {initSnapSlider} from './utils/snap-slider.js';
import { formatUrl } from './utils/urlFormatter.js';
import {getUrl} from "./utils/router.js";

const carouselList = document.querySelectorAll('.topic-carousel');

if (carouselList.length) {
    carouselList.forEach(async function (listEl) {
        const dataFacet = listEl.dataset.facet;
        const dataSlug = listEl.dataset.slug;
        const skLoader = listEl.querySelector('.sk-load-box-row');
        const carouselInner = listEl.querySelector('.scroll-snap-slider');
        let data, hauptfacette;

        try {
            const payload = await fetch(`/api/aps/main-facet/${dataFacet}`);
            data = await payload.json();
        } catch (error) {
            skLoader.remove();

            const errorEl = document.createElement('section');
            errorEl.classList.add('loading-error');
            errorEl.innerHTML = `
                <div>
                    <p class="loading-error-title">Ein Fehler ist aufgetreten.</p>
                    <p class="loading-error-content">
                        <span>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</span>
                        <a href="/" class="button" title="Zur Startseite wechseln">Zur Startseite wechseln</a>
                    </p>
                </div>
            `;
            listEl.appendChild(errorEl);
        }

        let loadedFacet = data?.Hauptfacette;
        if (loadedFacet !== null) {
            hauptfacette = {
                id: loadedFacet.DokNr,
                title: loadedFacet.Label,
                filterId: loadedFacet.Facette,
                items: [],
            };
            hauptfacette.items = loadedFacet.Eintrag.map(entry => {
                const imgSrc = loadedFacet.attachments.attachment.filter(attachment => attachment.id === entry.Medium)
                return {
                    id: entry.Medium,
                    title: entry.Anzeigename || entry.Suchterm,
                    searchTerm: entry.Suchterm,
                    count: entry.Treffer || 0,
                    src: imgSrc,
                    facet: loadedFacet.Facette
                };
            });

            createCarouselItems(carouselInner, hauptfacette.items);
            createCarouselLastItem(carouselInner, dataSlug);

            skLoader.remove();
            listEl.classList.add('loaded');
            initSnapSlider(listEl);
        }
    });

    function createCarouselLastItem(parent, slug) {
        const itemEl = document.createElement('div');
        itemEl.classList.add('scroll-snap-slide');
        itemEl.innerHTML = `
            <div class="topic-carousel_item-single">
                <a href="/facette/${slug}" class="topic-carousel_item-tile" title="Alle ansehen">
                    <p>Alle ansehen</p>
                    <div data-overlay="true" class="topic-carousel_item_overlay"></div>
                </a>
            </div>
        `;
        parent.appendChild(itemEl);
    }
    function createCarouselItems(parent, items) {
        items.forEach((item, index) => {
            if(index >= 14) return;
            const url = {
                pathname: getUrl('search'),
                query: {
                    q: '*',
                    ...(item.searchTerm !== null ? {requiredfields: `"${item.facet}:${item.searchTerm}"`} : {}),
                },
            };
            const itemEl = document.createElement('div');
            itemEl.classList.add('scroll-snap-slide');
            itemEl.dataset.index = index;
            itemEl.innerHTML = `
                <a href="${formatUrl(url)}" title="Suchen nach '${item.title}'">
                    <div class="topic-carousel_item_img-wrap">
                        <div class="topic-carousel_item_image" style="background-image: url(${item.src[0].thumbnail});">
                            <img src="${item.src[0].thumbnail}" class="visually-hidden" alt="${item.title}">
                        </div>
                        <div data-overlay="true" class="topic-carousel_item_overlay"></div>
                    </div>
                    <p class="topic-carousel_item_headline">${item.title}</p>
                    <p class="topic-carousel_item_subline">${item.count.toLocaleString('de-DE')} Dokumente</p>
                </a>
            `;
            parent.appendChild(itemEl);
        });
    }
}